import React from "react";
import "./component.scss";

const StatisticsCard = ({ label, count, icon, color, onClick }) => {
  return (
    <div
      className="stat-card-compact"
      onClick={onClick}
      style={{ cursor: "pointer" }}   
    >
      <div className="stat-label-wrapper">
        {icon ? (
          <span className="stat-icon">{icon}</span>
        ) : (
          <span className="stat-dot" style={{ backgroundColor: color }}></span>
        )}
        <span className="stat-label">{label}</span>
      </div>

      <div className="stat-count">{count}</div>
    </div>
  );
};

export default StatisticsCard;
